module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/OptionsIcon.35ba56f5.svg";